import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  getReferral,
  getReferralVariables,
} from '../../../../models/graphqlTypes'
import { GET_REFERRAL_BY_ID } from '../../../../operations/patientReferralOperations'
import { ReferralById } from '../types/patientReferrals.types'

type Options = QueryHookOptions<getReferral, getReferralVariables>

export type UseReferralByIdReturn = {
  loading: boolean
  referral?: ReferralById
}

export const useReferralById = (options: Options): UseReferralByIdReturn => {
  const { data, loading } = useQuery<getReferral, getReferralVariables>(
    GET_REFERRAL_BY_ID,
    options
  )

  return {
    referral: data?.getReferral,
    loading,
  }
}
